import React, { Component } from 'react';
import SearchLayout from './SearchLayout';
import '../css/style.css';
import '../components/Home.css';
import EventPagingLayout from './EventPagingLayout';
import { translate } from "react-i18next";
import { TEMPORARY, DEACTIVATED } from '../backend/Backend';
import {GREEN_BG, GREEN_BORDER} from '../backend/Colors';
import { Row, Col, Button } from 'react-bootstrap';

class MyEventsLayout extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            showPage: '0'
        }
    }

    handleChange(page) {
        this.setState({
            showPage: page
        });
    }

   
    render() {
        const { t } = this.props;
        const { params } = this.props.match
        return (<SearchLayout  eventKey="1" title={t("myEvents")} searchType="ACTIVTY" bg={GREEN_BG} bgStrong={GREEN_BORDER}>
            <div className="mt-3 ">
                <Row >
                    <Col>
                        <Button variant={this.state.showPage === '0' ? "success" : "outline-success"} onClick={() => this.handleChange("0")} className="float-left mt-3 ml-2">{t("events")}</Button>
                        <Button variant={this.state.showPage === '1' ? "success" : "outline-success"} onClick={() => this.handleChange("1")} className="float-left mt-3 ml-2">{t("NichtAbgeschlossen")}</Button>
                        <Button variant={this.state.showPage === '2' ? "success" : "outline-success"} onClick={() => this.handleChange("2")} className="float-left mt-3 ml-2">{t("deactivatEvents")}</Button>
                    </Col>
                </Row>
                {this.state.showPage === '0' ?
                    <div>
                        <Row className="mt-2 ml-2">
                            <Col >
                               {t("allMyCreatedEvents")}
                            </Col>
                        </Row>
                        <Row className="mt-2 ">
                            <Col >
                                <EventPagingLayout preURL="events/created" id={params.id} edit={true} />
                            </Col>
                        </Row>
                    </div>
                    : ''}
                {this.state.showPage === '1' ?
                    <div>
                        <Row className="mt-3 ml-2">
                            <Col >
                            {t("allMyNotFinished")}
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col >
                                <EventPagingLayout preURL="events/userAndStatus" id={params.id} edit={true} eventStatus={TEMPORARY} />
                            </Col>
                        </Row>
                    </div>
                    : ''}
                 {this.state.showPage === '2' ?
                    <div>
                          <Row className="mt-3 ml-2">
                            <Col >
                            {t("deactivatEventsLabel")}
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col >
                                <EventPagingLayout preURL="events/userAndStatus" id={params.id} edit={true} eventStatus={DEACTIVATED} />
                            </Col>
                        </Row>
                    </div>
                    : ''}



            </div>
        </SearchLayout>)
    }

}

export default translate("translations")(MyEventsLayout);